import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import { Utils } from '../../services';
import { Field } from 'redux-form';
import { DateTimePicker } from '../../components';
import moment from 'moment';

/** Class representing a PDF layout custom text field. */
class DatetimeField extends TextField {

    constructor(properties) {
        super({
            ...(DatetimeField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.DATETIME;
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();
        Utils.langs().forEach(lang => { properties.label[lang] = "";  });

        properties.with_time = true;

        return properties;
    }

    /**
     * Return the list of options this field handles
     */
    getHandledOptions() {
        return super.getHandledOptions().concat([
            FormLayout.OPTION_WITH_TIME
        ]);
    }

    /**
     * Return this field preview input
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(props) {
        return (
            <Field
                component="input"
                type={ !!this.with_time ? 'datetime-local' : 'date'}
                name={this.id}
                required={!!this.required}
                className="form-control"
            />
        );
    }

    /**
     * Render a value
     *
     * @param {Any} value
     * @param {Object} context: an object with the following keys:
     *                   - lang (mandatory)
     *                   - t (mandatory)
     *                   - format (optional)
     *
     * @return {String}
     */
    renderValue(value, context) {
        const format = context.format || (!!this.with_time ? 'LLL' : 'LL');

        return moment(value).format(format);
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'calendar-o';
    }
}

export default DatetimeField;
